import { RadixDappToolkit, DataRequestBuilder } from '@radixdlt/radix-dapp-toolkit'

const dAppId = 'account_rdx12y6fhc8chhdtsd46eve4cge5zagw6mjqrk3r87aa9dc6flll79y87q'

export const rdt = RadixDappToolkit({
  dAppDefinitionAddress: dAppId,
  networkId: 1, 
  applicationName: 'CAPYCLUB',
  applicationVersion: '1.0.0',
})

console.log('RadixDappToolkit initialized:', rdt)

export const getRdt = () => rdt

export { DataRequestBuilder }